/* ==========================================================
   NEREO GALLERY
   Parte 1/3
========================================================== */

document.addEventListener('DOMContentLoaded', () => {

  const slider = document.querySelector('.nereo-gallery');

  if (!slider) return;

  const slides = slider.querySelectorAll('.nereo-gallery__slide');

  const prev = slider.querySelector('.nereo-gallery__prev');

  const next = slider.querySelector('.nereo-gallery__next');

  const dots = slider.querySelectorAll('.nereo-gallery__dot');

  const thumbs = slider.querySelectorAll('.nereo-gallery__thumb');

  let current = 0;

  function updateGallery() {

    slides.forEach((slide, index) => {

      slide.classList.toggle('active', index === current);

    });

    dots.forEach((dot, index) => {

      dot.classList.toggle('active', index === current);

    });

    thumbs.forEach((thumb, index) => {

      thumb.classList.toggle('active', index === current);

    });

  }

  function nextSlide() {

    current++;

    if (current >= slides.length) {

      current = 0;

    }

    updateGallery();

  }

  function prevSlide() {

    current--;

    if (current < 0) {

      current = slides.length - 1;

    }

    updateGallery();

  }

  updateGallery();
    if (prev) {

    prev.addEventListener('click', () => {

      prevSlide();

    });

  }

  if (next) {

    next.addEventListener('click', () => {

      nextSlide();

    });

  }

  dots.forEach((dot, index) => {

    dot.addEventListener('click', () => {

      current = index;

      updateGallery();

    });

  });

  thumbs.forEach((thumb, index) => {

    thumb.addEventListener('click', () => {

      current = index;

      updateGallery();

    });

  });

  document.addEventListener('keydown', (event) => {

    if (event.key === 'ArrowRight') {

      nextSlide();

    }

    if (event.key === 'ArrowLeft') {

      prevSlide();

    }

  });

  let autoPlay = setInterval(() => {

    nextSlide();

  }, 6000);

  slider.addEventListener('mouseenter', () => {

    clearInterval(autoPlay);

  });

  slider.addEventListener('mouseleave', () => {

    autoPlay = setInterval(() => {

      nextSlide();

    }, 6000);

  });
  /* ==========================================================
   NEREO GALLERY
   Parte 3/3
========================================================== */

  let touchStartX = 0;
  let touchEndX = 0;

  slider.addEventListener('touchstart', (event) => {

    touchStartX = event.changedTouches[0].clientX;

  }, { passive: true });

  slider.addEventListener('touchend', (event) => {

    touchEndX = event.changedTouches[0].clientX;

    const distance = touchStartX - touchEndX;

    if (Math.abs(distance) < 50) return;

    if (distance > 0) {

      nextSlide();

    } else {

      prevSlide();

    }

    clearInterval(autoPlay);

    autoPlay = setInterval(() => {

      nextSlide();

    }, 6000);

  }, { passive: true });

  window.addEventListener('resize', () => {

    updateGallery();

  });

});